
import { ChangeDetectionStrategy, Component, effect, input, ViewEncapsulation } from '@angular/core';
import { CellRenderer, Column } from './cell-renderer';

@Component({
  selector: 'cbre-data-column-renderer, [cbreDataColumnRenderer]',
  template: ` {{ value }} &nbsp; `,
  imports: [],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultColumnRendererComponent<T = Record<string, any>> {
  readonly data = input<T>({} as T);
  readonly config = input<Column>();
  public value = null;

  constructor() {
    effect(() => {
      const data = this.data() ?? ({} as T);
      const config = this.config();
      if (config?.displayFn != null) {
        this.value = config.displayFn(data);
      } else {
        this.value = data[config?.path || config?.field];
      }
    });
  }

  render(): void {
    // required by CellRenderer
  }
}
